import { LogAdapter } from 'library/ts/utilities/logger/adapters/LogAdapter';
export class ConsoleLogAdapter extends LogAdapter {
    static #instance;
    static create = () => {
        if (!ConsoleLogAdapter.#instance)
            ConsoleLogAdapter.#instance = new ConsoleLogAdapter();
        return ConsoleLogAdapter.#instance;
    };
    #base;
    constructor() {
        super();
        this.#base = console;
    }
    log = (...messages) => {
        this.#base.log(...messages);
    };
    info = (...messages) => {
        this.#base.info(...messages);
    };
    warn = (...messages) => {
        this.#base.warn(...messages);
    };
    error = (...messages) => {
        this.#base.error(...messages);
    };
    group = (...messages) => {
        this.#base.group(...messages);
    };
    groupCollapsed = (...messages) => {
        this.#base.groupCollapsed(...messages);
    };
    groupEnd = (...messages) => {
        this.#base.groupEnd();
    };
    table = (...messages) => {
        this.#base.table(...messages);
    };
}
